import { ReactNode } from 'react';
import styled from 'styled-components';

import { FullWidthContainer } from '@sorare/core/src/atoms/layout/FullWidthContainer';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { useIsLaptop } from '@sorare/core/src/hooks/device/useIsLaptop';
import { tabletAndAbove } from '@sorare/core/src/style/mediaQuery';

const Root = styled(FullWidthContainer)`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  align-items: center;
  column-gap: var(--unit);
  padding: var(--triple-unit) var(--double-unit);

  @media ${tabletAndAbove} {
    padding: var(--triple-unit);
  }
`;
const Left = styled.div`
  margin-right: auto;
`;
const Center = styled(Vertical).attrs({ center: true, gap: 2 })`
  grid-column: 2 / 3;
`;
const Right = styled.div`
  margin-left: auto;
`;

type Props = {
  title?: ReactNode;
  sort?: ReactNode;
  eventTypeSwitcher?: ReactNode;
  overview?: ReactNode;
};
export const FixtureTabLayoutHeader = ({
  title,
  sort,
  eventTypeSwitcher,
  overview,
}: Props) => {
  const isLaptopAndAbove = useIsLaptop();
  return (
    <Root>
      <Left>{sort}</Left>
      <Center gap={2} center>
        {!!eventTypeSwitcher && <div>{eventTypeSwitcher}</div>}
        {title}
      </Center>
      {!!isLaptopAndAbove && <Right>{overview}</Right>}
    </Root>
  );
};
